import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <section className="footer text-center   position-relative" id="contact">
        <div className="footer_in">
          <div className="container position-relative">
            <div className="row">
              <div className="col-md-10  m-auto">
                <h2 className="hadding br bl bb mb-0 p-3">
                  Are you ready to ride the
                  <br />
                  <span className="color1">V2 memecoin wave?</span>
                </h2>
                <div className="social_icon  br bl bb pt-4 pb-4">
                  <a href="https://x.com/ScottyThe_Ai" className="btn btn_border me-3" target="_blank"> 
                    <img src="/assets/img/t2.svg" alt="t2" />
                  </a>
                  <a href="https://t.me/SCOTTY_Ai" className="btn btn_border" target="_blank"> 
                    <img src="/assets/img/t4.svg" alt="t4" />
                  </a>
                </div>
                <div className="bl br bl pt-4 pb-4 pb-md-5">
                  <p className="fw300">
                    The team actively engages with the community through social
                    media and other channels, making it a truly community-driven
                    project.
                  </p>
                  <button
                    type="button"
                    className="btn btn_bg pe-5 ps-5 mt-3 ttu"
                  >
                    click here to login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-md-10  m-auto">
              <small className="fw200">
                {" "}
                © 2025 by Scotty V2. All rights reserved!
              </small>
              <h4 className="color1 mt-4 mb-4">DISCLAIMER</h4>
              <p className="fw200">
                {" "}
                Yo, crypto ain't for the faint of heart. $SCOTTY could moon or
                send you straight to rekt city—no guarantees, no refunds, just
                pure degen energy. Do your own research, pay your taxes (or
                don’t, we’re not the feds), and only ape in with what you’re
                cool losing. Regulations? They exist. Probably. Stay safe, stay
                based, and send it responsibly. 🚀
              </p>
            </div>
          </div>
        </div>
      </section>

    </>
  );
}

export default Footer;
